'use client'
import { dayDiff, getFormattedDate, getMonthRange } from '@/src/utils/date/dateHelper'
import { isEmpty } from '@/src/utils/generalUtils/isEmpty'
import { ArrowBack, ArrowForward } from '@mui/icons-material'
import { Box, useTheme } from '@mui/material'
import classNames from 'classnames'
import { useTranslations } from 'next-intl'
import { useEffect, useState } from 'react'
import DayPicker, { DateUtils } from 'react-day-picker'
import 'react-day-picker/lib/style.css'
import './_calendar.scss'

const Calendar = ({
    selectedDates = [],
    className = '',
    title = '',
    roundTrip,
    onClickCalendar,
    priceData,
    activeOnward,
    activeReturn,
    isRtl,
    isMulticity,
    multiCityDestinations,
    index,
    fromMonth,
    toMonth,
    numberOfMonths = 2,
    ...otherProps
}: any) => {
    const theme = useTheme()
    const tMonths = useTranslations('form.months')

    const NO_OF_MONTHS = numberOfMonths

    const today = fromMonth ? fromMonth : new Date()
    toMonth = toMonth ? toMonth : new Date(new Date().setFullYear(new Date().getFullYear() + 1))
    const [selectedDate, setSelectedDate] = useState(selectedDates['from'])
    const locale = 'AE'
    const [range, setRange] = useState(selectedDates)
    const dayPickerClassName = classNames(className, {
        Selectable: roundTrip && !isRtl,
        'Selectable--rtl': isRtl && roundTrip
    })
    const { from, to, enteredTo } = range
    const modifiers = {
        start: from,
        end: enteredTo,
        leftEdge: { daysOfWeek: [1] },
        rightEdge: { daysOfWeek: [0] }
    }
    const disabledDays = {
        before:
            isMulticity && index > 1 && !isEmpty(multiCityDestinations[`depart_date_${index - 1}`])
                ? new Date(getFormattedDate(multiCityDestinations[`depart_date_${index - 1}`], 'MM/DD/YYYY'))
                : activeReturn && range.from
                  ? range.from
                  : today,
        after: toMonth
    }
    const { fareCalendar = {}, directionClick } = otherProps

    useEffect(() => {
        setRange(selectedDates)
    }, [selectedDates])

    function isSelectingFirstDay(from: any, to: any, day: any) {
        if (roundTrip && activeReturn) {
            const isBeforeFirstDay = from && DateUtils.isDayBefore(day, from)
            const isRangeSelected = from && to
            return !isBeforeFirstDay || isRangeSelected
        }
        if (isMulticity) {
            // && index > 1 && !isEmpty(multiCityDestinations[`depart_date_${index - 1}`])) {
            const isBeforeFirstDay = from && DateUtils.isDayBefore(day, from)
            const isRangeSelected = from && to
            return !isBeforeFirstDay || isRangeSelected
        }
        return false
    }

    function handleDayMouseEnter(day: any) {
        const { from, to } = range
        if (isSelectingFirstDay(from, to, day)) {
            setRange((prev: any) => ({ ...prev, enteredTo: day }))
        }
    }
    function handleDayClick(day: any) {
        if (roundTrip && activeOnward) {
            if (from && to) {
                let diff = dayDiff(day, to)
                if (diff >= 1) {
                    setSelectedDate(day)
                    onClickCalendar({
                        from: day,
                        to: day,
                        enteredTo: day
                    })
                } else {
                    setSelectedDate(day)
                    onClickCalendar({
                        ...range,
                        from: day
                    })
                }
            } else if (from && isEmpty(to)) {
                setSelectedDate(day)
                onClickCalendar({
                    ...range,
                    from: day
                })
            }
            // Clevertap.event('Air_UI_Action', {
            //     action_type: 'BUTTON',
            //     action_name: 'SRP_OW_Date_Selected'
            // })
        } else if (activeReturn) {
            // Clevertap.event('Air_UI_Action', {
            //     action_type: 'BUTTON',
            //     action_name: 'SRP_RT_Date_Selected'
            // })
            setSelectedDate(day)
            onClickCalendar({
                ...range,
                to: day,
                enteredTo: day
            })
        } else {
            // Clevertap.event('Air_UI_Action', {
            //     action_type: 'BUTTON',
            //     action_name: 'SRP_OW_Date_Selected'
            // })
            setSelectedDate(day)
            onClickCalendar({
                from: day,
                to: null,
                enteredTo: null
            })
        }
    }
    function nextClick(onNextClick: any, previousMonth: any) {
        let monthRange = getMonthRange(previousMonth, 'right')
        directionClick(monthRange)
        onNextClick()
    }
    function previousClick(onPreviousClick: any, previousMonth: any) {
        let monthRange = getMonthRange(previousMonth, 'left')
        directionClick(monthRange)
        onPreviousClick()
    }
    function Navbar({ onPreviousClick, onNextClick, previousMonth, nextMonth }: any) {
        return (
            <>
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        padding: '0 20px',
                        position: 'absolute',
                        width: '100%'
                    }}
                >
                    <Box>
                        {(previousMonth.getFullYear() === today.getFullYear() &&
                            previousMonth.getMonth() < today.getMonth()) ||
                        (previousMonth.getFullYear() < today.getFullYear() &&
                            previousMonth.getMonth() > today.getMonth()) ? (
                            isRtl ? (
                                <ArrowForward height={24} width={24} className="c-neutral-200" />
                            ) : (
                                <ArrowBack height={24} width={24} className="c-neutral-200" />
                            )
                        ) : isRtl ? (
                            <ArrowForward
                                data-testid="leftArrow"
                                height={24}
                                width={24}
                                className="c-pointer"
                                onClick={() => previousClick(onPreviousClick, previousMonth)}
                            />
                        ) : (
                            <ArrowBack
                                data-testid="leftArrow"
                                height={24}
                                width={24}
                                className="c-pointer"
                                onClick={() => previousClick(onPreviousClick, previousMonth)}
                            />
                        )}
                    </Box>

                    <Box>
                        {nextMonth.getTime() > toMonth.getTime() ? (
                            isRtl ? (
                                <ArrowBack
                                    height={24}
                                    width={24}
                                    style={{ alignSelf: 'flex-end' }}
                                    className="c-neutral-200"
                                />
                            ) : (
                                <ArrowForward
                                    height={24}
                                    width={24}
                                    style={{ alignSelf: 'flex-end' }}
                                    className="c-neutral-200"
                                />
                            )
                        ) : isRtl ? (
                            <ArrowBack
                                data-testid="rightArrow"
                                height={24}
                                width={24}
                                style={{ alignSelf: 'flex-end' }}
                                className="c-pointer"
                                onClick={() => nextClick(onNextClick, previousMonth)}
                            />
                        ) : (
                            <ArrowForward
                                data-testid="rightArrow"
                                height={24}
                                width={24}
                                style={{ alignSelf: 'flex-end' }}
                                className="c-pointer"
                                onClick={() => nextClick(onNextClick, previousMonth)}
                            />
                        )}
                    </Box>
                </Box>
            </>
        )
    }

    const renderDay = (day: Date) => {
        const date = day.getDate()
        // --- Selection logic ---
        const isStart = roundTrip && from && DateUtils.isSameDay(day, from)
        const isEnd = roundTrip && to && DateUtils.isSameDay(day, to)
        const isSelected = (!roundTrip && selectedDate && DateUtils.isSameDay(day, selectedDate)) || isStart || isEnd
        const isInRange = roundTrip && from && to && DateUtils.isDayAfter(day, from) && DateUtils.isDayBefore(day, to)
        const isHoveredRange =
            roundTrip && from && enteredTo && DateUtils.isDayAfter(day, from) && DateUtils.isDayBefore(day, enteredTo)
        // --- Disabled date logic ---
        const isDisabled =
            DateUtils.isDayBefore(day, today) ||
            (isMulticity &&
                index > 1 &&
                !isEmpty(multiCityDestinations[`depart_date_${index - 1}`]) &&
                DateUtils.isDayBefore(
                    day,
                    new Date(getFormattedDate(multiCityDestinations[`depart_date_${index - 1}`], 'MM/DD/YYYY'))
                )) ||
            (activeReturn && range.from && DateUtils.isDayBefore(day, range.from))

        // --- Style logic ---
        let bgColor = 'transparent'
        let color = '#1a1a1a'
        let border = 'none'
        let borderRadius = 0.5
        let cursor = 'pointer'

        if (isDisabled) {
            color = '#9e9e9e' // grey text for disabled dates
            cursor = 'not-allowed'
        } else if (isSelected) {
            bgColor = theme.palette.primary.main
            color = '#fff'
        } else if (isInRange || isHoveredRange) {
            bgColor = 'rgba(25, 118, 210, 0.08)' // light blue-gray for range
            color = '#1a1a1a'
        }

        return (
            <Box
                role="button"
                tabIndex={isDisabled ? -1 : 0}
                sx={{
                    width: 40,
                    height: 40,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: 16,
                    fontWeight: 500,
                    backgroundColor: bgColor,
                    color,
                    border,
                    borderRadius,
                    cursor,
                    transition: 'background 0.2s',
                    WebkitTapHighlightColor: 'transparent',
                    touchAction: 'manipulation',
                    '&:hover':
                        !isDisabled && roundTrip && !isStart && !isEnd
                            ? {
                                  backgroundColor: theme.palette.primary.main,
                                  color: '#fff'
                              }
                            : {}
                }}
            >
                {date}
            </Box>
        )
    }
    const MONTHS = [
        tMonths('january'),
        tMonths('february'),
        tMonths('march'),
        tMonths('april'),
        tMonths('may'),
        tMonths('june'),
        tMonths('july'),
        tMonths('august'),
        tMonths('september'),
        tMonths('october'),
        tMonths('november'),
        tMonths('december')
    ]

    const weekSort = ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa']
    const weekSortAr = ['أحد', 'إثنين', 'ثلاثاء', 'أربعاء', 'خميس', 'جمعة', 'سبت']
    const FIRST_DAY_OF_WEEK: { [key: string]: number } = {
        IN: 1,
        AE: 0,
        SA: 0,
        KW: 0,
        BH: 0,
        QA: 0,
        OM: 0,
        ME: 0
    }
    return (
        <>
            <DayPicker
                {...otherProps}
                numberOfMonths={NO_OF_MONTHS}
                interactionDisabled={true}
                renderDay={renderDay}
                className={dayPickerClassName}
                weekdaysShort={isRtl ? weekSortAr : weekSort}
                firstDayOfWeek={FIRST_DAY_OF_WEEK[locale]}
                disabledDays={disabledDays}
                fromMonth={today}
                toMonth={toMonth}
                modifiers={modifiers}
                locale={isRtl ? 'ar' : 'en'}
                months={MONTHS}
                month={
                    isMulticity && index > 1 && !isEmpty(multiCityDestinations[`depart_date_${index - 1}`])
                        ? new Date(getFormattedDate(multiCityDestinations[`depart_date_${index - 1}`], 'MM/DD/YYYY'))
                        : range['from']
                } // This is to be change wrt return / onward selection
                selectedDays={roundTrip ? [from, { from, to: enteredTo }] : selectedDate}
                navbarElement={<Navbar />}
                onDayClick={day => handleDayClick(day)}
                onDayMouseEnter={day => handleDayMouseEnter(day)}
            />
        </>
    )
}

export default Calendar
